import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { SignatureService } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const listSignatureServices = (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<SignatureService[]> | undefined> =>
  constructGet<NonPaginatedResponse<SignatureService[]>>(
    `${SIGNATURE_BASE_PATH}/services`,
    { params },
    { transformerSet: TransformerSet.PreserveKeys },
  );
